import * as yup from 'yup';

export type EditEmployeeFormValues = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
};

type Translate = (key: string, replace?: Record<string, unknown>) => string;

const optionalNameField = (t: Translate) =>
    yup
        .string()
        .max(50, t('max_length', {max: 50}))
        .test('length-if-filled', t('length_between', {min: 2, max: 50}), (value) => {
            const s = String(value ?? '').trim();
            if (s.length === 0) return true;
            return s.length >= 2 && s.length <= 50;
        });

export const getEditEmployeeSchema = (t: Translate) =>
    yup.object().shape({
        firstName: optionalNameField(t),
        lastName: optionalNameField(t),
        email: yup
            .string()
            .max(50, t('max_length', {max: 50}))
            .test('email-if-filled', t('email'), (value) => {
                const s = String(value ?? '').trim();
                if (s.length === 0) return true;
                return yup
                    .string()
                    .email()
                    .isValidSync(value);
            }),
        phone: yup.string().max(50, t('max_length', {max: 50})),
    });
